import "./pages/Common.css";

import {createTheme, Grid, ThemeProvider} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import React, {useRef, useState} from "react";

import {Route, Routes, useNavigate} from "react-router-dom";
import {signOut} from "aws-amplify/auth";
import {useAuthenticator} from "@aws-amplify/ui-react";
import Footer from "./Footer";
import About from "./pages/About";
import Achievements from "./pages/Achievements";
import Projects from "./pages/Projects";
import BlogPost from "./pages/BlogPost";
import BlogForm from "./pages/BlogForm";
import Contact from "./pages/Contact";
import Donation from "./pages/Donation";
import Login from "./pages/Login";
import Programs from "./pages/Programs";

const theme = createTheme({
    palette: {
        primary: {
            main: "#000000"
        }
    }
});

function App() {
    const navigate = useNavigate();
    const {user} = useAuthenticator((context) => [context.user]);
    const isSignedIn = !!user?.signInDetails?.loginId;
    const [showSignOutDialog, setShowSignOutDialog] = useState(false);
    const ref = useRef(null);

    async function handleSignOut() {
        await signOut();
        setShowSignOutDialog(false);
        navigate("/projects");
    }

    return (
        <div ref={ref}>
            <ThemeProvider theme={theme}>
                <Grid container spacing={2} alignItems="center" className="grid header-color">
                    <Grid item xs={4}>
                        <header>
                            <img src="/header.png" width={90} height={70} alt="" style={{cursor: "pointer"}}
                                 onClick={() => navigate("")}/>
                        </header>
                    </Grid>
                    <Grid container item xs={8} alignItems="flex-end" justifyContent="flex-end">
                        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                            <Button className="button-text-color" variant="text" onClick={() => navigate("/about")}>
                                About
                            </Button>
                            <Button className="button-text-color" variant="text" onClick={() => navigate("/projects")}>
                                Projects
                            </Button>
                            {isSignedIn ? (
                                <>
                                    <Button className="button-text-color" variant="text" onClick={() => navigate("/login")}>
                                        Donation Records
                                    </Button>
                                    <Button className="button-text-color" variant="text" onClick={() => setShowSignOutDialog(true)}>
                                        Sign Out
                                    </Button>
                                </>
                            ) : (
                                <Button className="button-text-color" variant="text" onClick={() => navigate("/login")}>
                                    Login
                                </Button>
                            )}
                        </Stack>
                    </Grid>
                </Grid>
            </ThemeProvider>
            <div>
                <Routes>
                    <Route exact path="/" element={<About/>}/>
                    <Route exact path="/about" element={<About/>}/>
                    <Route exact path="/contact" element={<Contact/>}/>
                    <Route exact path="/donation" element={<Donation/>}/>
                    <Route exact path="/programs" element={<Programs/>}/>
                    <Route exact path="/projects" element={<Projects/>}/>
                    <Route exact path="/achievements" element={<Achievements/>}/>
                    <Route exact path="/login" element={<Login/>}/>
                    <Route exact path="/blog_form" element={<BlogForm/>}/>
                    <Route exact path="/blog_form/:id" element={<BlogForm/>}/>
                    <Route exact path="/blog_post/:id" element={<BlogPost/>}/>
                </Routes>
            </div>
            <div style={{height: "100px"}}></div>
            <Footer/>
            <Dialog open={showSignOutDialog} onClose={() => setShowSignOutDialog(false)}>
                <DialogTitle>Sign Out</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to sign out?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowSignOutDialog(false)}>Cancel</Button>
                    <Button onClick={handleSignOut}>Sign Out</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default App;
